"use client";

import { createContext, useContext } from "react";

// بنرهای بالای هدر برای مسیر لود اولیه، که layout سرور از قبل می‌گیرد. BannerProvider هسته بنرها را فقط بعد از
// hydration در مرورگر می‌گیرد، پس تصویر بنر در HTML نبود و تا چند ثانیه بعد دانلود نمی‌شد؛ در صفحه‌ای مثل جستجوی
// مجله که تصویر بزرگ‌تری ندارد همین بنر عنصر LCP است (Lighthouse: LCP ~۱۰ ثانیه، ۸ ثانیه‌اش تأخیر کشف).
// فقط برای همان مسیری که سرور رندر کرده مقدار دارد؛ بعد از ناوبری کلاینتی null است.
const InitialBannersContext = createContext(null);

export const InitialBannersProvider = ({ value, children }) => (
    <InitialBannersContext.Provider value={value || null}>{children}</InitialBannersContext.Provider>
);

export const useInitialBanners = () => useContext(InitialBannersContext);
